import Vue from 'vue'

const state = {
  visible: false
}

const getters = {
  visible: state => state.visible,
  sidebarContent: state => state.sidebarContent
}

const actions = {
  toggleSidebar ({ commit }, payload) {
    commit(`TOGGLE_SIDEBAR`, payload)
  },

  setSidebarContent ({ commit }, payload) {
    commit(`SAVE_SIDEBAR_CONTENT_TO_STATE`, payload)
  }
}

const mutations = {
  TOGGLE_SIDEBAR (state, payload) {
    state.visible = payload || payload === false ? payload : !state.visible
  },

  SAVE_SIDEBAR_CONTENT_TO_STATE (state, payload) {
    Vue.set(state, `sidebarContent`, payloady)
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
